"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.feeTypeToService = exports.feeTypeLabel = void 0;
function feeTypeLabel(feeType) {
    switch (feeType) {
        case 'monthly-rpo':
            return 'Monthly RPO';
        case 'prepayment':
            return 'Prepayment';
        case 'placement':
            return 'Placement';
        case 'monthly-contractor':
            return 'Monthly Contractor';
        case 'monthly-sourcer':
            return 'Monthly Sourcer';
    }
}
exports.feeTypeLabel = feeTypeLabel;
function feeTypeToService(feeType) {
    switch (feeType) {
        case 'monthly-rpo':
            return 'Monthly Recruiting';
        case 'placement':
            return 'Candidate Placement';
        case 'monthly-contractor':
            return 'Monthly Contractor';
        case 'monthly-sourcer':
            return 'Monthly Recruiting';
        default:
            return undefined;
    }
}
exports.feeTypeToService = feeTypeToService;
//# sourceMappingURL=fee.js.map